module.exports = __webpack_public_path__ + "static/media/layer-group-solid-dark.78707704.png";